<template>
  <fragment>
    <template v-if="data.physicians != null">
      <div class="text-center v2_font_weight_semibold v2_font_size_32 mr-2">
        {{ data.physicians }}
      </div>
      <div class="d-flex align-items-center">
        physicians with ICOs in your specialty
      </div>
    </template>
  </fragment>
</template>

<script>
export default {
  name: 'IcoStatistics',
  props: {
    data: Object,
  },
};
</script>

<style scoped />
